import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ColDef } from 'ag-grid-community';

import { NSEBillConstants } from '@ruby/configs/ebill.constants';
import { IEBillTbtTocDetails } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-tbt-toc',
  templateUrl: './ebill-tbt-toc.component.html',
  styleUrls: ['./ebill-tbt-toc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EBillTbtTocComponent {
  @Input() invoice!: string;
  @Input() loading!: boolean;
  @Input() isDownloading!: boolean;
  @Input() details?: IEBillTbtTocDetails;
  @Input() columns!: Array<ColDef>;
  @Output() reload = new EventEmitter();
  @Output() downloadExcel = new EventEmitter();
  displayedColumns: Array<string> = NSEBillConstants.tbtTocDetailSummaryGridColumns;

  constructor(private location: Location) { }

  /**
   * Navigate Back
   *
   * @summary return to bill details
   * @return void
   */
  navigateBack(): void {
    this.location.back();
  }
}
